/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedIconBubbleEmail_viewer = {
    readonly isPdpStfEnabled?: boolean | null;
    readonly " $refType": "PdpSharedIconBubbleEmail_viewer";
};
export type PdpSharedIconBubbleEmail_viewer$data = PdpSharedIconBubbleEmail_viewer;
export type PdpSharedIconBubbleEmail_viewer$key = {
    readonly " $data"?: PdpSharedIconBubbleEmail_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedIconBubbleEmail_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedIconBubbleEmail_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchPdp",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchPdp",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": "isPdpStfEnabled",
          "name": "featureFlag",
          "args": [
            {
              "kind": "Literal",
              "name": "feature",
              "value": "enablePdpStf"
            }
          ],
          "storageKey": "featureFlag(feature:\"enablePdpStf\")"
        }
      ]
    }
  ]
};
(node as any).hash = 'c7c1d7b2b8ee00ca36ff393b4cc2126a';
export default node;
